import React from 'react'
import './Otherspage.css'

function Otherspage() {
  return (
    <div>
        
        OOP!
      
    </div>
  )
}

export default Otherspage;
